import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import '../App.css';
export default function TemporaryDrawer() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const links = ['','gallery', 'LogIn', 'about'];

  return (
    <div className="">
      <Button onClick={toggleDrawer(true)} >
        <svg className="w-8" fill="#ffffff" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 6.749h-28c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h28c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25zM18 14.75h-16c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h16c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25zM8.053 22.75h-6.053c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h6.053c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25z" />
        </svg>
      </Button>

      {/* Drawer Animation from the right */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: open ? "0%" : '-100%', // Initially hidden, slides in when open is true
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          color: 'white',
          transition: 'right 0.5s ease-in-out', // Smooth animation for sliding in/out
          zIndex: 1300, // Ensure it's above other content
        }}
        
      >
        <List sx={{ paddingTop: '20px', display: open ? 'block' : 'none' }} >
          <svg className="ml-4 mt-1 w-8 mr-auto cursor-pointer" fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" onClick={toggleDrawer(false)}>
            <path d="M30 6.749h-28c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h28c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25zM18 14.75h-16c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h16c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25zM8.053 22.75h-6.053c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25h6.053c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25z" />
          </svg>
          {['خانه','گالری', 'ورود / ثبت نام ', 'درباره ما'].map((text, index) => (
            <ListItem key={text}  disablePadding sx={{
              position: 'relative',
              width:'fit-content',
              '&:after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '0%',
                height: '2px',
                backgroundColor: '#a3e635',
                transition: 'all 0.4s ease',
              },
              '&:hover': {
                color: '#a3e635',
                transition: 'all 0.4s ease',
                '&::after': {
                  width: '100%',
                  transition: 'all 0.4s ease',
                },
              },
            }} className={`transition-transform animate-text list-item-animate-delay-${index + 1}`}>
              <ListItemButton component={Link} to={`/${links[index]}`}>
                <ListItemText primary={<span className="fanoos-text" >{text}</span>} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </div>
  );
}
